import * as React from 'react';
import { styled } from '@mui/material/styles';

const StyledSVG = styled('svg')(() => ({
  width: 'auto',
  height: 48,
}));

// const StyledPath = styled('path')(() => ({
//   fill: '#7df3e1',
// }));

const StyledCls1 = styled('polygon')(() => ({
  fill: '#ffffff',
}));

const StyledCls2 = styled('polygon')(() => ({
  fill: 'url(#linear-gradient)',
}));

const StyledCls3 = styled('polygon')(() => ({
  fill: 'url(#linear-gradient-2)',
}));

const StyledCls4 = styled('path')(() => ({
  fill: '#a1a1a4',
}));

const StyledCls5 = styled('path')(() => ({
  fill: '#38bde7',
}));

export const AgeroLogo = () => {
  return (
    <StyledSVG
      id="LOGO_TAGLINE_RGB"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 343.9 149.08"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="238.78"
          y1="13.02"
          x2="343.9"
          y2="13.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#e51a24" />
          <stop offset="0.18" stopColor="#e61f29" />
          <stop offset="0.41" stopColor="#e72e38" />
          <stop offset="0.66" stopColor="#ea4850" />
          <stop offset="0.92" stopColor="#ee6a71" />
          <stop offset="1" stopColor="#ef767c" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="261.48"
          y1="52.56"
          x2="343.9"
          y2="52.56"
          xlinkHref="#linear-gradient"
        />
      </defs>
      <StyledCls1 points="251.8 26.04 261.48 45.4 343.9 0 251.8 26.04" />
      <StyledCls2 points="238.78 0 251.8 26.04 343.9 0 238.78 0" />
      <StyledCls3 points="343.9 0 261.48 45.4 291.34 105.12 343.9 0" />
      <StyledCls4
        d="M59.15,49.06h9.18L94,108.69H81.89L76.33,95.06H50.47l-5.39,13.63H33.21ZM72.62,86,63.44,61.7,54.09,86Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M141.36,68.27v36.8c0,14.58-7.08,23.84-22.83,23.84-7.49,0-14.32-1.6-20-6.65l6.07-8.26c4,3.71,8.26,5.82,13.9,5.82,9.77,0,12.8-5.56,12.8-13.56v-3h-.17c-2.94,4-8.17,5.9-13.22,5.9-12.13,0-20.13-9.26-20.13-20.72,0-12,7.49-21.22,20-21.22,5.64,0,10.95,2.18,13.9,7.07h.17V68.27ZM107.84,88.4a11.67,11.67,0,0,0,11.87,11.71c7.5,0,12-5.14,12-11.88,0-7-4.63-11.87-12-11.87C112.72,76.36,107.84,81.24,107.84,88.4Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M159.69,92a10.48,10.48,0,0,0,10.87,9.61c5.05,0,8.33-2.35,10.86-5.47l7.25,5.47a21,21,0,0,1-17.1,8.09c-12.22,0-22-8.51-22-21.23s9.77-21.22,22-21.22c11.29,0,19,7.92,19,22V92Zm20.72-7.57c-.08-5.89-4-9.6-10.27-9.6-6,0-9.69,3.79-10.45,9.6Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M198.88,68.27H209v6.4h.17a12.86,12.86,0,0,1,12-7.41,13.25,13.25,0,0,1,3.63.58v9.78a19.78,19.78,0,0,0-4.89-.76c-9.51,0-10.86,8-10.86,10.19v21.64H198.88Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M250.14,67.26c12.2,0,22,8.5,22,21.22s-9.78,21.23-22,21.23-22-8.51-22-21.23S237.92,67.26,250.14,67.26Zm0,33.35c7.41,0,11.87-5.81,11.87-12.13s-4.46-12.12-11.87-12.12-11.88,5.81-11.88,12.12S242.72,100.61,250.14,100.61Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M279.61,105.26a4.74,4.74,0,1,1-4.68-4.29A4.5,4.5,0,0,1,279.61,105.26Zm-8.26,0a3.47,3.47,0,0,0,3.58,3.46,3.41,3.41,0,0,0,3.5-3.42,3.54,3.54,0,0,0-7.08,0Zm2.83,2.24h-1.06v-4.29a12,12,0,0,1,1.76-.13,2.5,2.5,0,0,1,1.55.34,1,1,0,0,1,.48.92c0,.52-.41.86-1,1v0c.46.13.68.46.82,1a3,3,0,0,0,.34,1H276a3,3,0,0,1-.37-1c-.08-.45-.36-.67-.95-.67h-.5Zm0-2.4h.5c.6,0,1.08-.18,1.08-.63s-.32-.66-1-.66a2.77,2.77,0,0,0-.6,0Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M34.23,149.15H40a11.48,11.48,0,0,1,2.37.24,5.82,5.82,0,0,1,2,.81,4.16,4.16,0,0,1,1.39,1.52,5,5,0,0,1,.51,2.37,5.31,5.31,0,0,1-.55,2.6,4,4,0,0,1-1.49,1.52A6.11,6.11,0,0,1,42,159a16.7,16.7,0,0,1-2.59.19H37.27v7.05h-3Zm4.86,7.39c.44,0,.89,0,1.35,0a4.06,4.06,0,0,0,1.29-.28,2.41,2.41,0,0,0,1-.73,2.55,2.55,0,0,0,0-2.61,2.26,2.26,0,0,0-.87-.72,3.6,3.6,0,0,0-1.18-.33c-.43,0-.85-.07-1.25-.07H37.27v4.79Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M48.12,160.42a6.21,6.21,0,0,1,.49-2.49A5.87,5.87,0,0,1,50,156a5.73,5.73,0,0,1,2-1.22,7.07,7.07,0,0,1,4.91,0,5.65,5.65,0,0,1,3.33,3.14,6.05,6.05,0,0,1,.5,2.49,6.12,6.12,0,0,1-.5,2.49,5.8,5.8,0,0,1-1.33,1.91,6,6,0,0,1-2,1.23,7.22,7.22,0,0,1-4.91,0,5.9,5.9,0,0,1-2-1.23,5.82,5.82,0,0,1-1.34-1.91A6.28,6.28,0,0,1,48.12,160.42Zm2.89,0a3.6,3.6,0,0,0,.23,1.3,3.19,3.19,0,0,0,.67,1.1,3.29,3.29,0,0,0,1.07.77,3.62,3.62,0,0,0,2.84,0,3.09,3.09,0,0,0,1.07-.77,3.22,3.22,0,0,0,.68-1.1,3.79,3.79,0,0,0,0-2.6,3.17,3.17,0,0,0-.68-1.11,3.23,3.23,0,0,0-1.07-.77,3.62,3.62,0,0,0-2.84,0,3.44,3.44,0,0,0-1.07.77,3.15,3.15,0,0,0-.67,1.11A3.6,3.6,0,0,0,51,160.42Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M61.84,154.64H65l2.5,8.09h0l2.34-8.09H73l2.5,8.09h.05l2.4-8.09h2.92l-3.93,11.55H74.07l-2.74-7.89h0l-2.43,7.89h-3Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M84.9,161.43a2.94,2.94,0,0,0,1,2,3.19,3.19,0,0,0,2.1.72,3.49,3.49,0,0,0,1.81-.44,5.1,5.1,0,0,0,1.29-1.12l2.07,1.56A5.78,5.78,0,0,1,90.92,166a6.58,6.58,0,0,1-2.63.53,6.9,6.9,0,0,1-2.45-.43,5.9,5.9,0,0,1-2-1.23,5.66,5.66,0,0,1-1.33-1.91,6.12,6.12,0,0,1-.5-2.49,6.05,6.05,0,0,1,.5-2.49,5.65,5.65,0,0,1,3.33-3.14,6.91,6.91,0,0,1,2.45-.44,5.65,5.65,0,0,1,2.21.42A4.83,4.83,0,0,1,92.21,156a5.56,5.56,0,0,1,1.1,2,8.17,8.17,0,0,1,.4,2.68v.8Zm5.92-2.17a2.71,2.71,0,0,0-.79-2,3,3,0,0,0-2.14-.73,2.82,2.82,0,0,0-2.06.74,3.32,3.32,0,0,0-.93,2Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M96.43,154.64h2.89v1.83h.05a3.6,3.6,0,0,1,1.37-1.56,3.77,3.77,0,0,1,2.05-.56,2.94,2.94,0,0,1,.51.05l.52.12v2.79l-.71-.15a4,4,0,0,0-.69-.06,3.08,3.08,0,0,0-1.62.37,3,3,0,0,0-.94.85,2.68,2.68,0,0,0-.43,1,3.13,3.13,0,0,0-.11.72v6.18H96.43Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M107.7,161.43a2.91,2.91,0,0,0,1,2,3.14,3.14,0,0,0,2.09.72,3.53,3.53,0,0,0,1.82-.44,5.1,5.1,0,0,0,1.29-1.12l2.07,1.56a5.81,5.81,0,0,1-2.27,1.78,6.53,6.53,0,0,1-2.62.53,6.92,6.92,0,0,1-2.46-.43,5.86,5.86,0,0,1-2-1.23,5.68,5.68,0,0,1-1.34-1.91,6.11,6.11,0,0,1-.49-2.49,6,6,0,0,1,.49-2.49,5.72,5.72,0,0,1,3.33-3.14,6.92,6.92,0,0,1,2.46-.44,5.6,5.6,0,0,1,2.2.42A4.66,4.66,0,0,1,115,156a5.74,5.74,0,0,1,1.11,2,8.44,8.44,0,0,1,.4,2.68v.8Zm5.92-2.17a2.72,2.72,0,0,0-.8-2,3,3,0,0,0-2.14-.73,2.84,2.84,0,0,0-2.06.74,3.37,3.37,0,0,0-.92,2Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M128.37,164.46h-.05a3.62,3.62,0,0,1-1.68,1.54,5.5,5.5,0,0,1-2.29.48A5.67,5.67,0,0,1,122,166a5.42,5.42,0,0,1-1.8-1.28A5.72,5.72,0,0,1,119,162.8a7.37,7.37,0,0,1-.38-2.38,6.71,6.71,0,0,1,.41-2.39,5.86,5.86,0,0,1,1.14-1.92,5.19,5.19,0,0,1,1.77-1.29,5.44,5.44,0,0,1,2.26-.47,5.71,5.71,0,0,1,1.45.17,5.25,5.25,0,0,1,1.1.43,4.52,4.52,0,0,1,.82.57,4.31,4.31,0,0,1,.56.59h.07V148h2.89v18.19h-2.75Zm-6.83-4a3.82,3.82,0,0,0,.22,1.3,3.38,3.38,0,0,0,.68,1.1,3.19,3.19,0,0,0,1.07.77,3.62,3.62,0,0,0,2.84,0,3.19,3.19,0,0,0,1.07-.77,3.38,3.38,0,0,0,.68-1.1,4,4,0,0,0,0-2.6,3.32,3.32,0,0,0-1.75-1.88,3.62,3.62,0,0,0-2.84,0,3.32,3.32,0,0,0-1.75,1.88A3.82,3.82,0,0,0,121.54,160.42Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M141.56,148h2.89v8.11h.07a4.31,4.31,0,0,1,.56-.59,4.2,4.2,0,0,1,.82-.57,5,5,0,0,1,1.1-.43,5.71,5.71,0,0,1,1.45-.17,5.48,5.48,0,0,1,2.26.47,5.19,5.19,0,0,1,1.77,1.29,5.86,5.86,0,0,1,1.14,1.92,6.94,6.94,0,0,1,.41,2.39,7.37,7.37,0,0,1-.38,2.38,5.58,5.58,0,0,1-1.14,1.93,5.22,5.22,0,0,1-1.8,1.28,5.71,5.71,0,0,1-2.38.47A5.5,5.5,0,0,1,146,166a3.69,3.69,0,0,1-1.69-1.54h0v1.73h-2.75Zm9.58,12.42a3.6,3.6,0,0,0-.23-1.3,3.15,3.15,0,0,0-.67-1.11,3.33,3.33,0,0,0-1.07-.77,3.62,3.62,0,0,0-2.84,0,3.23,3.23,0,0,0-1.07.77,3.32,3.32,0,0,0-.68,1.11,3.79,3.79,0,0,0,0,2.6,3.38,3.38,0,0,0,.68,1.1,3.09,3.09,0,0,0,1.07.77,3.62,3.62,0,0,0,2.84,0,3.28,3.28,0,0,0,1.74-1.87A3.6,3.6,0,0,0,151.14,160.42Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M155.19,154.64h3.17l3.23,8h0l2.89-8h3l-5.46,14a8.8,8.8,0,0,1-.69,1.44,4.17,4.17,0,0,1-.87,1,3.44,3.44,0,0,1-1.2.63,6,6,0,0,1-1.64.2,8.67,8.67,0,0,1-2.22-.29l.36-2.6a7.36,7.36,0,0,0,.71.21,3.84,3.84,0,0,0,.76.08,3.75,3.75,0,0,0,.89-.09,1.72,1.72,0,0,0,.62-.31,1.84,1.84,0,0,0,.42-.52c.11-.22.23-.48.36-.79l.55-1.37Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M225.28,153.73c-.06-1.36-.32-2.2-.89-2.6a4.93,4.93,0,0,0-2.8-.52H216c-2.34,0-3.49.39-3.53,2.64,0,2.41.71,3,3.57,3h6.25c1.92,0,3.09.33,4,1.23a4.45,4.45,0,0,1,1.3,3.57c0,1.66-.26,2.72-1.26,3.67a5.32,5.32,0,0,1-4,1.25h-6.88c-1.9,0-3.17-.36-4-1.23a4.94,4.94,0,0,1-1.28-3.5l2.17-.38c.07,1.34.32,2.24,1,2.64a2.11,2.11,0,0,0,.78.32,8.18,8.18,0,0,0,1.9.16h5.84c2.86,0,3.6-.65,3.58-3,0-1.19-.26-1.61-.65-2-.61-.56-1.34-.72-3-.72h-6.25c-1.9,0-3-.36-3.9-1.24a4.54,4.54,0,0,1-1.3-3.49c0-1.67.34-3,1.3-3.76s2.07-1.24,4-1.24h6.6c1.93,0,3.16.38,4,1.26s1.17,1.58,1.3,3.49Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M241.63,148.58H244l6.62,14.75,6.61-14.75h2.41l-8,17.56h-2.1l-4.33-9.58-4.4,9.58h-2.09l-8-17.56h2.42l6.61,14.76,4.27-9.46Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M280.4,160.48c0,2.46-.31,3.33-1.32,4.29s-2,1.22-4,1.22h-6.88c-1.93,0-3.18-.33-4.06-1.21s-1.28-1.84-1.3-4.21v-6.86c0-1.93.38-3.05,1.29-3.92s2.11-1.23,4-1.23h6.93c1.92,0,3.07.35,3.88,1.16s1.33,1.76,1.38,3.9Zm-11.61-9.91c-3.21-.06-3.65.81-3.68,3.49v6.16c0,3.09.57,3.8,3.67,3.77h5.83c3.09,0,3.6-.67,3.61-3.77v-6.16c0-2.62-.51-3.56-3.59-3.49Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M302.48,160.48c0,2.46-.31,3.33-1.31,4.29s-2,1.22-4,1.22h-6.89c-1.93,0-3.18-.33-4.05-1.21s-1.28-1.84-1.31-4.21v-6.86c0-1.93.39-3.05,1.29-3.92s2.11-1.23,4-1.23h6.93c1.93,0,3.07.35,3.88,1.16s1.33,1.76,1.38,3.9Zm-11.61-9.91c-3.2-.06-3.65.81-3.68,3.49v6.16c0,3.09.58,3.8,3.67,3.77h5.83c3.09,0,3.6-.67,3.62-3.77v-6.16c0-2.62-.52-3.56-3.6-3.49Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls4
        d="M319.37,148.59a5.09,5.09,0,0,1,3.9,1.24c1,.9,1.31,2.16,1.28,4.13v1.73c0,1.92-.32,3-1.22,3.91s-2.05,1.29-4.27,1.28h-9.8V166h-2.17V148.58Zm-10.11,10.28h9.34c3,0,3.74-.56,3.75-3.54v-1c0-3.22-.69-3.76-3.84-3.74h-9.25Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls5
        d="M205.26,151.32a1.5,1.5,0,0,1-.75.08l-29.27-1-.41,0a.51.51,0,0,1-.39-.12.47.47,0,0,1,.26-.82c.37,0,28.26-.89,31.05-1a.73.73,0,0,1,.59.14c.23.22,0,.62,0,.62l-.73,1.6A1,1,0,0,1,205.26,151.32Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls5
        d="M202,158.53a1.5,1.5,0,0,1-.75.08l-18.63-1a.59.59,0,0,1-.39-.12.46.46,0,0,1,.26-.82l20-1a.7.7,0,0,1,.59.14c.23.22,0,.61,0,.61l-.73,1.6A1,1,0,0,1,202,158.53Z"
        transform="translate(-33.21 -22.89)"
      />
      <StyledCls5
        d="M198.7,165.74a1.4,1.4,0,0,1-.75.08l-7.53-.93c-.16,0-.26,0-.38-.12a.46.46,0,0,1,.26-.82l8.89-1a.68.68,0,0,1,.58.14c.24.23,0,.62,0,.62l-.73,1.6A1,1,0,0,1,198.7,165.74Z"
        transform="translate(-33.21 -22.89)"
      />

      <StyledCls4
        d="M331.35,150.7a2.37,2.37,0,1,1-2.34-2.14A2.25,2.25,0,0,1,331.35,150.7Zm-4.12,0a1.73,1.73,0,0,0,1.78,1.73,1.71,1.71,0,0,0,1.76-1.71,1.77,1.77,0,0,0-3.54,0Zm1.41,1.12h-.53v-2.15a6.13,6.13,0,0,1,.88-.06,1.24,1.24,0,0,1,.78.17.53.53,0,0,1,.24.46c0,.26-.21.43-.48.51v0c.23.07.34.23.41.53a1.81,1.81,0,0,0,.17.52h-.56a1.73,1.73,0,0,1-.19-.52c0-.22-.18-.33-.47-.33h-.25Zm0-1.2h.25c.3,0,.54-.09.54-.32s-.16-.33-.49-.33a1.05,1.05,0,0,0-.3,0Z"
        transform="translate(-33.21 -22.89)"
      />
    </StyledSVG>
  );
};
